import axios from 'axios';
import BaseAPI from './base/base-api';

class ConfirmGoodsVatRateAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'confirmGoodsVatRate';
}

export default new ConfirmGoodsVatRateAPI();